export const MENU_BUTTON_TEST_ID = 'menu-button';
export const MENU_ICON_TEST_ID = 'menu-icon';
